import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

export const Modal = (ReactElement, isClose) => {
  if (!Modal.queue) Modal.queue = [];
  if (ReactElement) {
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(
      <Wrapper>
        <div>
          <div>
            {isClose ? (
              <span
                onClick={() => {
                  Modal();
                }}
              />
            ) : null}
            {ReactElement}
          </div>
        </div>
      </Wrapper>,
      div
    );
    setTimeout(() => {
      div.querySelector("div").classList.add("focus");
    }, 100);
    Modal.queue.push(div);
    return div;
  } else {
    const div = Modal.queue.pop();
    if (div) {
      div.querySelector("div").classList.remove("focus");
      setTimeout(() => {
        div.parentNode.removeChild(div);
      }, 400);
    }
  }
};

const Wrapper = styled.div`
  & {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: auto;
    z-index: 16;
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0.25s,
      opacity 0.25s;
  }
  &.focus {
    visibility: visible;
    opacity: 1;
  }
  &.focus > div > div > div {
    transform: translateY(0);
  }

  & > div {
    position: relative;
    display: table;
    width: 100%;
    height: 100%;
  }
  & > div > div {
    display: table-cell;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    text-align: center;
  }
  & > div > div > div {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin: 50px 0;
    width: 85%;
    background-color: white;
    border-radius: 10px;
    text-align: left;
    font-size: 1rem;
    box-sizing: border-box;
    overflow: hidden;
    transform: translateY(25px);
    transition: transform 0.25s;
  }
  & > div > div > span {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  & > div > div > div.medium {
    max-width: 768px;
  }
  & > div > div > div.small {
    max-width: 480px;
  }
  & > div > div > div.tiny {
    max-width: 320px;
  }

  & > div > div > div > .top {
    position: relative;
    padding: 10px 25px;
    border-bottom: var(--border);
    text-align: center;
    font-size: 1.35rem;
    font-weight: bold;
  }

  & > div > div > div > .middle {
    padding: 0 25px 25px 25px;
  }

  & > div > div > div > .bottom {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    height: var(--lineHeight);
    border-top: 1px solid var(--border);
    text-align: right;
  }
  & > div > div > div > .bottom > div {
    display: inline-flex;
  }
  & > div > div > div > .bottom .cancel {
    color: var(--red);
  }
  & > div > div > div > .bottom .submit {
    color: var(--green);
  }
  & > div > div > div > .bottom button {
    margin: 0;
    padding: 5px 10px;
    width: auto;
    background-color: white;
    border: none;
    line-height: 1;
  }
  & > div > div > div > .bottom button:focus {
    box-shadow: none;
  }
`;

export default Modal;
